/**
 * Catálogo de parciales usado en filtros de Reporte de Calificaciones.
 * El valor debe coincidir con el enum del backend (EscCalificacion.tipo_evaluacion).
 */
export const PARCIALES = [
  { value: 'PARCIAL1', label: 'Parcial 1' },
  { value: 'PARCIAL2', label: 'Parcial 2' },
  { value: 'PARCIAL3', label: 'Parcial 3' },
];

export const PARCIAL_DEFAULT = 'PARCIAL1';
